import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';

import { Location } from '@era/locations-sdk';

@Component({
  selector: 'era-location-select-ui',
  templateUrl: './location-select.component.html',
  styleUrls: ['./location-select.component.scss'],
  imports: [ReactiveFormsModule],
})
export class LocationSelectComponent implements OnInit, OnChanges {
  @Input() isEnabled: boolean;
  readonly selectLocation = new UntypedFormControl('');

  @Input() locations: Location[];
  @Input() location: Location;

  @Output() readonly locationChange = new EventEmitter<Location>();

  ngOnChanges(changes) {
    if (changes.location?.currentValue) {
      this.selectLocation.setValue(changes.location.currentValue);
    }
  }

  ngOnInit() {
    this.selectLocation.valueChanges.subscribe((location) => {
      this.locationChange.emit(location);
    });
  }
}
